import {
  ActivityTypeMetricsDto,
  RemediationActivityTypeDto
} from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import { ELSProgressBar } from '../els.components';
import { getPercent } from '../../utilities/remediation.utilities';
import React from 'react';

export type ActivityProgressBarProps = {
  metricCounts: ActivityTypeMetricsDto;
  activityType: RemediationActivityTypeDto;
};

export const ActivityProgressBar = (props: ActivityProgressBarProps): JSX.Element => {
  const {
    metricCounts,
    activityType
  } = props;

  if (!metricCounts) {
    return null;
  }

  let progress = activityType === RemediationActivityTypeDto.ASSESS_BY_CONTENT_TYPE && metricCounts.activityTypeTotalGoalCompleted > 0
    ? metricCounts.activityTypeTotalGoalCompleted / metricCounts.activityTypeAttemptGoal
    : metricCounts.progress

  if (metricCounts.activityTypeTotalGoal === 0) {
    progress = 1;
  }

  return (
    <div className={`c-nra-activity-progress-bar c-nra-activity-progress-bar--${activityType.toLowerCase()}`}>
      <ELSProgressBar progressNum={progress} totalNum={1} />
      {
        activityType === RemediationActivityTypeDto.ASSESS_BY_CONTENT_TYPE && (
          <div
            style={{
              left: `${getPercent(metricCounts.activityTypeTotalGoal, metricCounts.activityTypeAttemptGoal)}%`,
              visibility: `${metricCounts.activityTypeTotalGoal === metricCounts.activityTypeAttemptGoal ? 'hidden' : 'visible'}`
            }}
            className="c-nra-activity-progress-bar__tick"
          />
        )
      }
    </div>
  );
};
